
import React from 'react'

export default function Pthreat() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>

                    <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Pathways of Threat</h4><br></br>
                    </div>
                    
                    <div>
                      <p>Without managing pathways of threat, management may be ineffective in the long-term as invasive alien species are successful because of their ability to disperse from many sources and through many processes.To determine a priority for response, mapping and monitoring is critical to identify where invasive species are dispersing from and at what rate. The following factors represent potential pathways for the spread of invasive species into and within Antigua and Barbuda:
</p>
                    </div>
                    <div>
                      <ul>
                        <ol>1. Ongoing development and associated movement of people and vehicles can result in the spread of invasive plant species and pathogens.</ol>
                        <ol>2. The continued selling and planting of invasive plants through nurseries and landscape businesses.</ol>
                        <ol>3. Limited community interest, knowledge and skills in identifying and managing invasive species.</ol>
                        <ol>4. Indiscriminate dumping of garden cuttings and IAS infested soil in parks and reserves.</ol>
                        <ol>5. Unrestricted access to highly significant forests in protected areas by recreational users.</ol>
                        <ol>6. Movement of machinery used in landscaping, maintenance and earthworks including soil disturbance.</ol>
                        <ol>7. Transporting of stock feed and soil.</ol>
                        <ol>8.  Movement of landscape materials, especially quarry products.</ol>
                        <ol>9. Properties with threats not managed due to age of owner,ability of residents, inexperience, absence and attitude.</ol>
                        <ol>10. Occurrence of fire and drought which impacts species establishment and expansion.</ol>
                        <ol>11.  Movement of invasive plants and pathogens by animals, spread bywater, wind movement and soil disturbance.</ol>

                      </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

